"use strict";

class PropertyKeyHandoverUnitSelectionController {

    constructor($scope, $timeout, $window, Upload, OTPService, SSHttpService, SSAppService, SSUtilService, SSUserService, SSStorageService, SSAlertService, SSConfirmationService, SSConfigService, SSAwsService, SSEoiService) {

        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;
        self.$window = $window;

        self.Upload = Upload;

        self.OTPService = OTPService;
        self.SSHttpService = SSHttpService;
        self.SSAppService = SSAppService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSStorageService = SSStorageService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;
        self.SSAwsService = SSAwsService;
        self.SSEoiService = SSEoiService;

        self.KEY_HANDOVER_STATUS_READY = SHOWSUITE.KEY_HANDOVER_STATUS_READY;
        self.KEY_HANDOVER_STATUS_SCHEDULED = SHOWSUITE.KEY_HANDOVER_STATUS_SCHEDULED;
        self.KEY_HANDOVER_STATUS_COMPLETED = SHOWSUITE.KEY_HANDOVER_STATUS_COMPLETED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;

        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.ASSET_MODEL_EOI_DOCUMENT = SHOWSUITE.ASSET_MODEL_EOI_DOCUMENT;
        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;
        self.ASSET_MODEL_SUBSALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SUBSALE_DOCUMENT;

        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;
        self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS;
        self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS;
        self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_RISK_ML;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.BENEFICIARY_IDENTITY_NRIC = SHOWSUITE.BENEFICIARY_IDENTITY_NRIC;
        self.BENEFICIARY_IDENTITY_PASSPORT = SHOWSUITE.BENEFICIARY_IDENTITY_PASSPORT;
        self.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE = SHOWSUITE.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE;

        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE;

        self.IDENTITY_TYPE_SINGAPOREAN = SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN;
        self.IDENTITY_TYPE_SINGAPORE_PR = SHOWSUITE.IDENTITY_TYPE_SINGAPORE_PR;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        // Units Import
        self.importParams = {};
        self.unitsDataFileProcessed = false;
        self.unitsImageFilesProcessed = false;
        self.unitAssets = {};

        /* WEB-2835 Key Handover: Final AML Scans and Form F  */
        self.is_key_handover_page = true;
        self.pageSize = 8; // Number of documents per page
        self.currentPage = 1; // Start with the first page

        self.risk_assessment_level_options = ["Low", "Medium", "High"];

        if(!self.SSUserService.getUser()){
            self.SSUserService.showLoginModal();
        }

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.buyers = [];
        self.searchParams = {};

        self.unit_status = 0;

        self.offset = 0;
        self.limit = 10;

        self.current = 1;
        self.jump_to_page = 1;

        self.category_type = [];
        self.floor_plan_type = [];

        self.prepareKeyHandoverStatuses();
        self.SSUtilService.deleteFromLocalStorage('unitForNewAppointment');

        self.select_status = [];
        self.search_types = [];
        self.search_categories = [];
        self.search_price_types = [];
        self.search_floorPlan = [];
        self.filtered_units = [];

        self.sortColumn = 'block_no';
        self.reverseSort = false;

        self.unitStatuses = [];
        self.unitStatusesFilter = [];
        self.edited_fields= [];
        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_SOLD,
            self.UNIT_STATUS_SPECIAL_RESERVED
        ];

        self.getFloorPlans();
        self.getUnits();

        self.setPageOptions();

        self.getPropertyQuestions();

        self.initReadyDatePicker();
    }

    /**
     * WEB-4304: Attach the jQuery UI datepicker to the Mark Ready date field.
     *
     * @remarks
     * The field lives inside a Bootstrap modal, so on jQuery UI 1.12.x the calendar renders
     * `position: fixed` with the document scrollTop still baked into its `top` and opens that far
     * below the input. `beforeShow` re-pins it on the next tick (a harmless recompute on 1.13+,
     * which fixed this upstream) — the same approach used by the SPA and Reversal modals.
     * The picker is NOT attached through the page's `datepicker` directive: re-initialising an
     * input that already has an instance is a silent no-op, so this init would not take effect.
     *
     * @returns {void}
     */
    initReadyDatePicker(){
        const self = this;

        self.$timeout(function () {
            $('.ready-date-input').datepicker({
                dateFormat: "dd/mm/yy",
                beforeShow: function (input, inst) {
                    if (!$(input).closest('.modal').length) {
                        return;
                    }
                    setTimeout(function () {
                        inst.dpDiv.css({
                            top: $(input).offset().top - $(document).scrollTop() + $(input).outerHeight(),
                            left: $(input).offset().left - $(document).scrollLeft()
                        });
                    }, 0);
                }
            });
        });
    }

    prepareKeyHandoverStatuses(){
        const self = this;

        self.keyHandoverStatuses = [
            {id: self.KEY_HANDOVER_STATUS_READY, name: 'READY', _class: 'text-success' },
            {id: self.KEY_HANDOVER_STATUS_SCHEDULED, name: 'SCHEDULED', _class: '' },
            {id: self.KEY_HANDOVER_STATUS_COMPLETED, name: 'COMPLETED', _class: 'text-primary' }
        ];
    }

    hasPermissionForProperty(permission, property_id){
        const self = this;

        if(permission && property_id){
            return self.SSUserService.hasPermissionForProperty(permission, property_id);
        }
    }

    getFloorPlans(){
    	const self = this;

    	self.types = self.SSConfigService.serverConfig.unit_types;
        self.categories = self.SSConfigService.serverConfig.unit_categories;
        self.price_types = self.SSConfigService.serverConfig.unit_price_types;

        let url = 'properties/' + self.data.property_id + '/floorplans';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.floorPlans = response.data.floorplans;

            jQuery.each(self.floorPlans, function (i, status) {
                self.search_floorPlan.push({id: status.name, title: status.name});
            });

        });

        jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
            if (self.editableStatus.indexOf(status.id) != -1) {
                self.unitStatuses.push(status);
                self.select_status.push({id:status.name, title:status.name});
            }
            self.unitStatusesFilter.push(status);
        });

        jQuery.each(self.types, function (i, status) {
            self.search_types.push({id:status.name, title:status.name});
        });

        jQuery.each(self.categories, function (i, status) {
            self.search_categories.push({id:status.name, title:status.name});
        });

        jQuery.each(self.price_types, function (i, status) {
            self.search_price_types.push({id:status.name, title:status.name});
        });


        self.modifyChanges = false;
        self.params = {
            property_id: self.data.property_id,
            status: self.unitStatuses[0]
        };

        self.param = {
            property_id: self.data.property_id
        };

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };
    }

    getUnits() {
        const self = this;

        if (!self.property.id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];
        self.firstWatch = null;

        let url = 'sec/developer/properties/' + self.property.id + '/units';

        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.UNITS_POPULATED = true;
            self.stacks = response.data.stacks;
            let units = angular.copy(response.data.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
            self.units = angular.copy(units);

            jQuery.each(self.units, function (i, unit) {
                self.formatUnitData(unit);
            });

            self.unitsBackup = self.units;

            self.count = self.unitsBackup.length;

            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch == "20" ) {
                        self.edited_units.push(newValue.id);
                    }
                });
            });

            self.units_master = angular.copy(self.units);
            self.units_master_converted = angular.copy(self.units);

            self.initSelectizejs();

            self.loadUnits(undefined, self.units_master);

            self.getPropertyUnitSaleIds();
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units){
        const self = this;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!units){
            if (self.filtered_units && self.filtered_units.length > 0) {
                units = angular.copy(self.filtered_units);
            } else {
                units = self.unitsBackup;
            }
        }

        self.units_master = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.units_master.length)){
            self.selected_units_display = self.limit;
        }
        else{
            self.selected_units_display = self.units_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);

        // For client side pagination
        self.pages = Math.ceil(self.count / self.limit);
        self.selectedPage = Math.floor(self.offset / self.limit) + 1;
        self.pagesArr = self.SSUtilService.getPageList(self.pages, self.selectedPage, 15);
    }

    backPage() {
        const self = this;

        self.selectedPage--;
        self.offset = self.offset - self.limit;
        self.loadUnits(self.searchFilter);
    }

    nextPage() {
        const self = this;

        self.selectedPage++;
        self.offset = self.offset + self.limit;
        self.loadUnits(self.searchFilter);
    }

    gotoPage(pageNum){
        const self = this;

        self.offset = parseInt(pageNum) * self.limit;
        self.loadUnits(pageNum);
    }

    createAppointment(){
        const self = this;

        let url = "/developer/properties/"+ self.property.named_id +"/key-handover";

        self.selected_units = self.getValidUnits();
        if(self.selected_units){
            if(self.selected_units.length > 1){
                self.select_units_error = "Please select only 1 unit for new appointment.";
                return;
            }

            let unit = self.units.find(x => x.id == parseInt(self.selected_units[0]));

            if(!unit){
                self.select_units_error = "Unit not found. Please try again later.";
                return;
            }
            else if(unit.key_handover_status != self.KEY_HANDOVER_STATUS_READY
                || unit.key_handover_status != self.KEY_HANDOVER_STATUS_READY){
                self.select_units_error = "Selected unit is not available for appointment.";
                return;
            }

            self.SSUtilService.saveToLocalStorage('newAppointment', true);
            self.SSUtilService.saveToLocalStorage('unitForNewAppointment', unit);

            window.location = url;
        }
    }

    onProceedUnitSelection(appointment_letter = false) {
        const self = this;

        self.appointment_letter = appointment_letter;

        self.selected_units = self.getValidUnits();
        if(self.selected_units){
            $("#keyhandoverGenerateLettersModal").modal("show");
        }
    }

    _onProceedUnitSelection() {
        const self = this;

        let url = "sec/developer/properties/"+ self.property.id +"/units/key-handover/generate-letter?regenerate_letter="+ (self.regenerate_letter? 1 : 0) + "&appointment_letter="+ (self.appointment_letter? 1 : 0);
        url = self.SSHttpService.getApiURL(url+"&unit_id="+self.selected_units.join(','));
        self.$window.open(url, '_blank');
        $("#keyhandoverGenerateLettersModal").modal("hide");

        let message = (self.appointment_letter? "Appointment letter(s)" : "QR code(s)")+ " generatered successfully.";
        self.SSAlertService.success('Success!', message);
        self.uncheckAllUnits();
    }

    getKeyHandoverStatus(status_code){
        const self = this;

        if(!status_code) return '--';

        let status = self.keyHandoverStatuses.find(x => x.id == status_code);

        if(status){
            return status.name;
        }
        else{
            return '--';
        }
    }

    // Units Furnishing Packages Import
    importFurnishingPackageUnits() {
        const self = this;

        if (!self.importParams.unitsExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadFurnishingPackageUnitsExcel(self.importParams.unitsExcelFile);
            }
        );
    }

    //construction units import
    importConstructionUnits(){
        const self = this;

        if (!self.importParams.unitsExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadConstructionUnitsExcel(self.importParams.unitsExcelFile);
            }
        );
    }

    uploadFurnishingPackageUnitsExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/units/furnishing-packages/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data.furnishing_packages) {
                self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                return;
            }

            self.importData = response.data;

            if (self.importParams.unitsAssetFiles && self.importParams.unitsAssetFiles.length) {
                self.uploadFurnishingUnitFiles(self.importParams.unitsAssetFiles);
            } else {
                // self._importUnits();
            }

        }, function (response) {

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadConstructionUnitsExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/units/construction-progress-update/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data.construction_progress) {
                self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                return;
            }

            self.importData = response.data;
            if (self.importParams.unitsAssetFiles && self.importParams.unitsAssetFiles.length) {
                self.uploadConstructionUnitFiles(self.importParams.unitsAssetFiles);
            } else {
                self._importConstructionProgress();
            }
        }, function (response) {

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadFurnishingUnitFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importFurnishingPackages();
                    }
                });
            });
        });
    }
    uploadConstructionUnitFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importConstructionProgress();
                    }
                });
            });
        });
    }



    _importUnits() {
        const self = this;

        let importUrl = 'sec/developer/import/units';

        let params = {
            property_id: self.property.id,
            units: self.importData.units,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Update local data
            jQuery.each(response.data.units, function (i, unit) {
                self.formatUnitData(unit);

                let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
                if (oldUnit) {
                    angular.merge(oldUnit, unit);
                } else {
                    self.units.push(unit);
                }
            });

            self.showImport = false;
            self.showConstructionImport = false;
            // self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };
        });
    }

    _importFurnishingPackages() {
        const self = this;

        let importUrl = 'sec/developer/import/units/furnishing-packages';

        let params = {
            property_id: self.property.id,
            furnishing_packages: self.importData.furnishing_packages,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Update local data
            // jQuery.each(response.data.units, function (i, unit) {
            //     self.formatUnitData(unit);
            //
            //     let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
            //     if (oldUnit) {
            //         angular.merge(oldUnit, unit);
            //     } else {
            //         self.units.push(unit);
            //     }
            // });

            self.showImport = false;
            // self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };
        });
    }
    _importConstructionProgress() {
        const self = this;

        let importUrl = 'sec/developer/import/units/construction-progress-update';

        let params = {
            property_id: self.property.id,
            construction_progress: self.importData.construction_progress,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

             // Display errors as warnings
             let errors = "";
             jQuery.each(response.data.errors, function (i, error) {
                 errors += "\n" + error;
             });
             if(errors.length > 0){
                 self.SSAlertService.warning("Warning!", errors);
             }

            // Update local data
            // jQuery.each(response.data.units, function (i, unit) {
            //     self.formatUnitData(unit);
            //
            //     let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
            //     if (oldUnit) {
            //         angular.merge(oldUnit, unit);
            //     } else {
            //         self.units.push(unit);
            //     }
            // });

            self.showImport = false;
            // self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };
        });
    }

    getStatusClass(status_code){
        const self = this;

        if(!status_code) return '';

        let status = self.keyHandoverStatuses.find(x => x.id == status_code);

        if(status){
            return status._class;
        }
        else{
            return '';
        }
    }

    /**
     * WEB-4304: Start the Mark Ready flow — the date is captured before the call is made.
     *
     * @remarks
     * The selection is validated first so "Please select at least 1 unit" appears on the page
     * (where the other unit-selection errors are shown) rather than inside the modal.
     *
     * @returns {void}
     */
    markAsReady(){
        const self = this;

        self.selected_units = self.getValidUnits();

        if(!self.selected_units){
            return;
        }

        self.openReadyDateModal('MARK_READY', self.selected_units);
    }

    /**
     * WEB-4304: Edit the ready date of a single already-marked unit (row icon).
     *
     * @param {Object} unit - The unit row; must already be marked ready.
     * @returns {void}
     */
    editReadyDate(unit){
        const self = this;

        if(!unit){
            return;
        }

        self.select_units_error = "";
        self.openReadyDateModal('EDIT_DATE', [unit.id.toString()], unit.key_handover_ready_date);
    }

    /**
     * WEB-4304: Edit the ready date of every checked unit (bulk action).
     *
     * @remarks
     * The BE rejects the whole request when any unit in the list is not marked ready, so the
     * selection is filtered here first and the user is told which rows were skipped.
     *
     * @returns {void}
     */
    editReadyDates(){
        const self = this;

        let selectedUnits = self.getValidUnits();

        if(!selectedUnits){
            return;
        }

        let readyUnits = selectedUnits.filter(function (unitId) {
            let unit = self.units.find(x => x.id == parseInt(unitId));
            return unit && unit.key_handover_status != null;
        });

        if(!readyUnits.length){
            self.select_units_error = "Please select at least 1 unit that is already marked as ready.";
            return;
        }

        if(readyUnits.length != selectedUnits.length){
            self.SSAlertService.warning('Warning!',
                (selectedUnits.length - readyUnits.length) +' selected unit(s) are not marked as ready and will be skipped.');
        }

        self.openReadyDateModal('EDIT_DATE', readyUnits);
    }

    /**
     * WEB-4304: Open the shared ready-date prompt.
     *
     * @param {string} mode - 'MARK_READY' or 'EDIT_DATE'; drives the modal copy and the endpoint.
     * @param {Array<string>} unitIds - Unit ids the chosen date will be applied to.
     * @param {string} [currentDate] - Existing `key_handover_ready_date` (YYYY-MM-DD) to prefill.
     * @returns {void}
     */
    openReadyDateModal(mode, unitIds, currentDate){
        const self = this;

        self.ready_date_mode = mode;
        self.ready_date_units = unitIds;
        self.ready_date_units_count = unitIds? unitIds.length : 0;
        self.ready_date_error = "";

        // Defaults to today; editing an existing date starts from the stored one.
        self.ready_date = currentDate?
            moment(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY');

        $("#keyhandoverReadyDateModal").modal("show");
    }

    /**
     * WEB-4304: Apply the chosen ready date.
     *
     * @remarks
     * MARK_READY posts to the existing mark-as-ready endpoint with the extra `ready_date` param;
     * EDIT_DATE posts to the date-only endpoint, which changes no status and sends no notifications.
     *
     * @returns {void}
     */
    proceedReadyDate(){
        const self = this;

        self.ready_date_error = "";

        if(!self.ready_date){
            self.ready_date_error = "Please select the ready date.";
            return;
        }

        let readyDate = moment(self.ready_date, 'DD/MM/YYYY', true);

        if(!readyDate.isValid()){
            self.ready_date_error = "Please enter a valid date in DD/MM/YYYY format.";
            return;
        }

        if(!self.ready_date_units || !self.ready_date_units.length){
            self.ready_date_error = "Please select at least 1 unit to proceed.";
            return;
        }

        let markReady = self.ready_date_mode != 'EDIT_DATE';

        let url = "sec/developer/properties/"+ self.property.id +"/units/key-handover/"
            + (markReady? "mark-as-ready" : "ready-date");

        let params = {
            unit_ids: self.ready_date_units.join(','),
            ready_date: readyDate.format('YYYY-MM-DD')
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.message) {
                    self.SSAlertService.danger('Not Allowed!', response.message);
                } else {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            $("#keyhandoverReadyDateModal").modal("hide");

            self.SSAlertService.success('Success!', markReady?
                'Unit(s) marked as ready successfully.' : 'Ready date updated successfully.');

            self.uncheckAllUnits();
            self.getUnits();
        });
    }

    markAsNotReady(unit){
        const self = this;

        if(!unit){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to reset this unit?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = "sec/developer/properties/"+ self.property.id +"/units/key-handover/mark-as-not-ready";
                let params = {
                    unit_ids: unit.id.toString()
                };

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Unit status updated successfully.');
                    self.getUnits();
                });
            });
    }

    addSaleBuyerCount(unit){
        const self = this;

        if(!unit){
            console.log('Invalid input params.')
            return;
        }

        self.selected_unit = unit;
        $("#keyhandoverSaleBuyerCountModal").modal("show");
    }

    proceedAddSaleBuyerCount(unit){
        const self = this;

        if(!self.sale_buyers_count){
            self.sale_buyers_count_error = "Please select the number of sale buyers.";
            return;
        }

        let url = "sec/developer/properties/"+ self.property.id +"/units/"+self.selected_unit.id+"/update-sale-buyers-count";
        let params = {
            sale_buyers_count: self.sale_buyers_count
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Unit updated successfully.');
            $("#keyhandoverSaleBuyerCountModal").modal("hide");
            self.getUnits();
        });
    }

    getValidUnits(){
        const self = this;

        self.select_units_error = "";

        var filteredUnits = Object.keys(self.checkboxes.items).reduce((p, c) => {
          if (self.checkboxes.items[c]) p[c] = self.checkboxes.items[c];
          return p;
        }, {});

        self.temp_units_arr = Object.keys(filteredUnits);

        if (self.temp_units_arr.length == 0) {
            //Display Error message
            self.select_units_error = "Please select at least 1 unit to proceed."
            return null;
        }

        return angular.copy(self.temp_units_arr);
    }

    uncheckAllUnits(){
        const self = this;

        self.checked = 0;
        // Uncheck all
        jQuery.each(self.unitsBackup, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
        });

        self.edited_status = "";
        self.checkboxes.count = self.checked;
        self.checkAll = false;
    }

    searchArray(array, id) {
        const self = this;

        if (!array || !id) return '';

        if (typeof array == "string") {
            array = self.serverConfig[array];
        }
        let object = null;
        jQuery.each(array, function(i, e) {
            if (e.id == id) {
                object = e;
            }
        });

        return object ? object.name : '';
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

 	initSelectizejs() {
        const self = this;

        self.clearSelectize('selectize_category');
        self.$timeout(function(){
            let $select = $('#selectize_category').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'asc',
                maxItems: null,
                options: self.categories,
                items: self.category_type
            });
        });

        self.clearSelectize('selectize_floor_plan');
        self.$timeout(function(){
            let $select = $('#selectize_floor_plan').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'asc',
                maxItems: null,
                options: self.floorPlans,
                items: self.floor_plan_type
            });
        });
    }

    clearSelectize(id){
        const self = this;

        if(!id){
            return;
        }

        try{
            let selectize = $("#" + id)[0].selectize;

            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    applySearch(){
        const self = this;

        var units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
            self.selectedPage = 1;
            self.current = 1;
            self.offset = 0;
        }

        self.filtered_units = angular.copy(units);

        self.loadUnits(undefined, units);
    }

    isSearchApplied(){
        const self = this;

        if(!self.block_no_search && !self.unit_no_search && !(self.category_type && self.category_type.length > 0) && !(self.floor_plan_type && self.floor_plan_type.length > 0)
            && !self.name_search && !self.price_type_search && !self.price_search && !self.psf_search && !self.status_search && !self.risk_level_search){

            return false;
        }
        else{
            return true;
        }
    }

    getFilteredUnits(){
        const self = this;

        let units = [];

        if (self.block_no_search) {
            units = self.unitsBackup.filter(x => x.block_no.toString().indexOf(self.block_no_search.trim()) > -1);
        }

        if (self.unit_no_search) {
            if (units.length > 0) {
                units = units.filter(x => x.named_id.toString().indexOf(self.unit_no_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.named_id.toString().indexOf(self.unit_no_search.trim()) > -1);
            }
        }

        if (self.category_type && self.category_type.length > 0) {
            if (units.length > 0) {
                units = units.filter(function(item) {
                  return self.category_type.indexOf(item.category.toString()) !== -1
                });
            } else {
                units = self.unitsBackup.filter(function(item) {
                  return self.category_type.indexOf(item.category.toString()) !== -1
                });
            }
        }

        if (self.floor_plan_type && self.floor_plan_type.length > 0) {
            if (units.length > 0) {
                units = units.filter(function(item) {
                  return self.floor_plan_type.indexOf(item.floor_plan_id.toString()) !== -1
                });
            } else {
                units = self.unitsBackup.filter(function(item) {
                  return self.floor_plan_type.indexOf(item.floor_plan_id.toString()) !== -1
                });
            }
        }

        if (self.name_search) {
            if (units.length > 0) {
                units = units.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            }
        }

        if (self.status_search) {
            if (units.length > 0) {
                units = units.filter(x => x.key_handover_status == self.status_search);
            } else {
                units = self.unitsBackup.filter(x => x.key_handover_status == self.status_search);
            }
        }
        if (self.risk_level_search) {
            if (units.length > 0) {
                units = units.filter(x => x.aml_risk_assessment_level == self.risk_level_search);
            } else {
                units = self.unitsBackup.filter(x => x.aml_risk_assessment_level == self.risk_level_search);
            }
        }

        return units;
    }

    toggleCheckAll(){
        const self = this;

        self.checked = 0;
        // Uncheck all to apply new changes
        jQuery.each(self.unitsBackup, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
        });

        self.edited_status = "";

        let units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(self.checkAll){
            // All units checked
            jQuery.each(units, function (index, unit) {
                if(unit.key_handover_status != self.KEY_HANDOVER_STATUS_COMPLETED){
                    self.checkboxes.items[unit.id] = true;
                    self.checked += 1;
                }
            });
            self.edited_status = "Changes will be applied to " + self.checked + " rows";
        }
        self.checkboxes.count = self.checked;
    }

    updateCount(is_check) {
        const self = this;

        is_check ? self.checkboxes.count++ : self.checkboxes.count--;
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }

        self.$timeout(function () {
            $("select#jump_to_page").niceSelect('update');
        });
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.formatted_floor_plan_type = self.searchArray(self.floorPlans, unit.floor_plan_id);
        unit.actual_price = unit.price;

        /**
         * WEB-4304: Mark Ready date, shown next to the key-handover status.
         *
         * @remarks
         * A plain date column with no time part — parsed as a local calendar date rather than
         * through the UTC helpers, which would shift it a day either way. Legacy units marked
         * ready before WEB-4303 have no date, and the API omits null dates entirely, so the
         * value is only formatted when it is actually present.
         */
        unit.formatted_key_handover_ready_date = unit.key_handover_ready_date?
            moment(unit.key_handover_ready_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        // By default set the 'checked' status to false
        unit.checked = false;

        return unit;
    }

    exportFurnishingPackages(){
        const self = this;
        let exportUrl = 'sec/developer/properties/' + self.data.property_id + '/units/export-furnishing-packages';

        let url = self.SSHttpService.getApiURL(exportUrl);
        // console.log(url);
        self.$window.open(url, '_blank');
    }
    exportConstructionProgress(){
        const self = this;
        let exportUrl = 'sec/developer/properties/' + self.data.property_id + '/units/export-construction-progress-update';

        let url = self.SSHttpService.getApiURL(exportUrl);
        self.$window.open(url, '_blank');
    }

    changeHeaderName(name){
        const self = this;
        if(!name) return;
        self.SSAlertService.clear();

        $("#header_key_handover")[0].innerHTML = name;
    }

    /* WEB-2835 Key Handover: Final AML Scans and Form F - START */
    amlRiskAssessment(unit){
        const self = this;

        self.SSAlertService.clear();
        $('#document_container').empty();

        //get unit documents
        if(!unit.sale_id){ return false; } // Must have sale_id
        self.getUnitSaleInfoAndDocuments(unit);
        self.getUnitSaleQuestionsAnswers(unit.sale_id);

        self.AML_RISK_ASSESSMENT_MODE = true;
    }

    cancelAmlRiskAssessment(mode = false) {
        const self = this;

        self.AML_RISK_ASSESSMENT_MODE = mode;
    }

    _amlRiskAssessment() {
        const self = this;

        self.aml_assessment_errors = {};
        $('#modelAmlRiskAssessment').modal('show');
    }

    getQuestionAnswer(question) {
        const self = this;

        if (!question) return;
        let answerText = null;
        if(self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)){
            answerText = self.aml_assessment.risk_value;
        } else if(self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)){
            answerText = self.aml_assessment.remarks;
        } else if(self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS)){
            if(self.aml_assessment.cdd_document === 'Yes'){
                answerText = self.aml_assessment.cdd_document;
            }else{
                answerText = self.aml_assessment.cdd_document_details;
            }
        }else if(self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS)){
            answerText = self.aml_assessment.consistent_transactions;
        }else if(self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML)){
            answerText = self.aml_assessment.risk_ml
        }
        return answerText;
    }

    updateRiskAssessment() {
        const self = this;
        if (!self.isValidAmlRiskInput()) return;
        let answers = {};

        $.each(self.questions, function (index, question) {
            answers[question.id] = self.getQuestionAnswer(question);
        });
        let url =
            "sec/sales/" + self.sale.id + "/questions-answers/save-multiple-key-handover";

        let params = { question_answers: JSON.stringify(answers) };
        $('#modelAmlRiskAssessment').modal('hide');

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (
            response
        ) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.units.map( um => {
                if(um.sale_id === self.sale.id){
                    um.aml_risk_assessment_level = self.getProcessedAMLRiskAssessmentLevel(self.aml_assessment.risk_value);
                }
                return um;
            })

            self.units_master.map( um => {
                if(um.sale_id === self.sale.id){
                    um.aml_risk_assessment_level = self.getProcessedAMLRiskAssessmentLevel(self.aml_assessment.risk_value);
                }
                return um;
            })
            self.cancelAmlRiskAssessment(false);
        });
    }

    isValidAmlRiskInput () {
        var self = this;

        var isValid = true;

        self.aml_assessment_errors = {};
        $.each(self.questions, function (index, question) {
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL) && question.is_required){
                if (!self.aml_assessment.risk_value) {
                    self.aml_assessment_errors.risk_value = "Please select risk assessment level.";
                    isValid = false;
                }
            }
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS) && question.is_required){
                let remarksMaxLength = self.SSConfigService.getAmlRiskAssessmentRemarksMaxLength();

                if (!self.aml_assessment.remarks || (self.aml_assessment.remarks && !self.aml_assessment.remarks.trim())) {
                    self.aml_assessment_errors.remarks = "Remarks are required.";
                    isValid = false;
                } else if (self.aml_assessment.remarks && self.aml_assessment.remarks.length > remarksMaxLength) {
                    self.aml_assessment_errors.remarks = "Only " + remarksMaxLength + " characters are allowed for remarks.";
                    isValid = false;
                }
            }
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS) && question.is_required){
                if (!self.aml_assessment.cdd_document) {
                    self.aml_assessment_errors.cdd_document = "Please provide answer.";
                    isValid = false;
                }

                if (self.aml_assessment.cdd_document === 'No' && !self.aml_assessment.cdd_document_details)  {
                    self.aml_assessment_errors.cdd_document_detail = "Please provide details.";
                    isValid = false;
                }
            }
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS) && question.is_required){
                if (!self.aml_assessment.consistent_transactions) {
                    self.aml_assessment_errors.consistent_transactions = "Please provide answer.";
                    isValid = false;
                }
            }
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML) && question.is_required){
                if (!self.aml_assessment.risk_ml) {
                    self.aml_assessment_errors.risk_ml = "Please provide answer.";
                    isValid = false;
                }
            }
        });
        return isValid;
    };

    getPropertyUnitSaleIds(){
        const self = this;

        let url = 'sec/developer/properties/'+self.data.property_id +'/units/sale_ids';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response && response.data && response.data.units){
                let unitSaleIdList = response.data.units;
                self.units = self.units.map( um => {
                    let filteredUnitSaleId = unitSaleIdList.filter( us =>  us.unit_id === um.id )[0];
                    if(filteredUnitSaleId){
                        um.sale_id = filteredUnitSaleId.sale_id;
                        um.aml_risk_assessment_level = self.getProcessedAMLRiskAssessmentLevel(filteredUnitSaleId.aml_risk_assessment_level);
                        um.sale_buyers_count = filteredUnitSaleId.sale_buyers_count;
                    }
                    return um;
                })

                /* Perform pagination action after loading sale_ids */
                self.units_master = angular.copy(self.units);
                self.loadUnits(undefined, self.units_master);
            }
        });
    }

    getProcessedAMLRiskAssessmentLevel(input){
        const self = this;
        if (angular.isArray(input)) {
            return input;
        } else if (angular.isString(input)) {
            try {
                let parsed = JSON.parse(input);
                if (angular.isArray(parsed)) {
                    return parsed;
                } else {
                    return [parsed];
                }
            } catch (e) {
                return [input];
            }
        }
    }

    getPropertyQuestions(){
        const self = this;
        self.questions = [];

        let url = 'sec/developer/properties/'+self.data.property.id +'/questions';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response && response.data && response.data.property_questions){
                let property_questions = response.data.property_questions.filter(item => item.is_active === 1);
                property_questions = _.sortBy(property_questions, "order");

                $.each(property_questions, function (index, question) {
                    /* Only need to load relevant questions */
                    if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)
                        || self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)
                        || self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS)
                        || self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS)
                        || self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML)){
                        self.questions.push(question);
                    }
                });
            }
        });
    }

    checkIfQuestionsHaveMarker(marker){
        const self = this;
        if(!self.questions) { return false; }
        return self.questions.filter(q => self.SSUtilService.compareQuestionMarker(q.marker, marker)).length > 0;
    }

    checkIfQuestionIsRequired(marker){
        const self = this;
        if(!self.questions) { return false; }
        return self.questions.filter(q => self.SSUtilService.compareQuestionMarker(q.marker, marker) && q.is_required).length > 0;
    }

    getUnitSaleQuestionsAnswers(saleId){
        const self = this;
        self.aml_assessment = {};
        self.aml_assessment_errors = {};

        let url = 'sec/sales/'+saleId+'/questions-answers';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response && response.data && response.data.question_answers){
                self.question_answers = response.data.question_answers;
                self.question_answers.forEach( qa => {
                    if(self.SSUtilService.compareQuestionMarker(qa.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)){
                        self.aml_assessment.risk_value = qa.answer_text;
                    }else if(self.SSUtilService.compareQuestionMarker(qa.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)){
                        self.aml_assessment.remarks = qa.answer_text;
                    }else if(self.SSUtilService.compareQuestionMarker(qa.marker, self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS)){

                        if(qa.answer_text === 'Yes'){
                            self.aml_assessment.cdd_document = qa.answer_text;
                            self.aml_assessment.cdd_document_details = qa.answer_text;
                        }else{
                            self.aml_assessment.cdd_document = 'No';
                            self.aml_assessment.cdd_document_details = qa.answer_text;
                        }
                    }else if(self.SSUtilService.compareQuestionMarker(qa.marker, self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS)){
                        self.aml_assessment.consistent_transactions = qa.answer_text;
                    }else if(self.SSUtilService.compareQuestionMarker(qa.marker, self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML)){
                        self.aml_assessment.risk_ml = qa.answer_text;
                    }
                })
            }
        });
    }

    nextPage() {
        const self = this;

        var totalPages = Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
        if (self.currentPage < totalPages) {
            self.currentPage++;
        }
    };

    previousPage() {
        const self = this;

        if (self.currentPage > 1) {
            self.currentPage--;
        }
    };

    hasMoreDocuments() {
        const self = this;

        if (!(self.sale && self.sale.other_documents)) return;

        return self.currentPage < Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
    };

    getCurrentDocument() {
        const self = this;

        if (!self.sale) return;

        var startIndex = (self.currentPage - 1) * self.pageSize;
        var endIndex = startIndex + self.pageSize;

        if (self.sale.other_documents) {
            return Object.values(self.sale.other_documents).slice(startIndex, endIndex);
        }

        return [];
    }

    getUnitSaleInfoAndDocuments(unit){
        const self = this;

        self.sale = {};

        let url = 'sec/sales/'+unit.sale_id;
        let params = {
            include: 'sale_buyers, documents, non_buyer_payees, beneficiaries, subsales',
            key_handover_review_docs: true
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response && response.data && response.data.sales && response.data.sales.length){
                let sales = response.data.sales[0];

                /* Parse buyers object */
                let buyers = sales.sale_buyers.map( b => {
                    let sale_buyer_id = b.id;
                    if(b.data){
                        try{
                            b = JSON.parse(b.data);
                            b.sale_buyer_id = sale_buyer_id;
                        }catch (e){
                            console.warn("An error occurred parsing buyer object",e);
                        }
                    }
                    return b;
                })

                // Process SubSales
                if( sales.subsales  && sales.subsales.length ){
                    sales.subsales = sales.subsales.map( subsale => {
                        subsale.subsale_buyers = subsale.subsale_buyers.map( b => {
                            let subsale_buyer_id = b.id;
                            if(b.data){
                                try{
                                    b = JSON.parse(b.data);
                                    b.subsale_buyer_id = subsale_buyer_id;
                                }catch (e){
                                    console.warn("An error occurred parsing subsale buyer object",e);
                                }
                            }
                            return b;
                        })
                        return subsale;
                    })
                }

                self.sale = {
                    id: sales.id,
                    buyers: buyers,
                    subsales: sales.subsales,
                    beneficiaries: sales.beneficiaries,
                    non_buyer_payees: sales.non_buyer_payees,
                    documents: sales.documents,
                    other_documents: [],
                    supporting_documents: []
                };

                /* Process documents to get presigned URLs */
                if (self.sale.buyers) {
                    self.processDocuments(self.sale.buyers, self.sale.documents, 'sale_buyer');
                }

                if (self.sale.non_buyer_payees) {
                    self.processDocuments(self.sale.non_buyer_payees, self.sale.documents, 'non_buyer_payee');
                }

                if (self.sale.beneficiaries) {
                    self.processDocuments(self.sale.beneficiaries, self.sale.documents, 'beneficiary');
                }

                if (self.sale.subsales && self.sale.subsales.length){
                    self.sale.subsales.forEach( subsale => {
                        self.processDocuments(subsale.subsale_buyers, self.sale.documents, 'subsale_buyer');
                    })
                }

                let sale_documents = self.sale.documents;
                $.each(sale_documents, function (i, document) {
                    if (document.format === self.PROPERTY_DOCUMENT_FORMAT_PDF) {
                        if (document.document_kind === self.PROPERTY_DOCUMENT_KIND_OTHER) {
                            document.model = self.ASSET_MODEL_SALE_DOCUMENT;
                            document.title = "Supporting Document - " + (document.name ? document.name : '');
                        } else {
                            document.model = self.ASSET_MODEL_SALE_DOCUMENT;
                            document.title = document.name ? document.name : '';
                        }
                        self.sale.other_documents.push(document);
                    }
                });
            }

            self.$timeout(function () {
                // Pre-Select Buyer Particulars doc if exist
                let buyer_particulars_doc = null;
                if(self.sale && self.sale.other_documents){
                    buyer_particulars_doc = self.sale.other_documents
                        .filter(d => d.document_kind === self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS);
                }
                if(buyer_particulars_doc && buyer_particulars_doc.length){
                    self.changeDisplayDoc(buyer_particulars_doc[0]);
                }else{
                    self.changeDisplayDoc(self.sale.other_documents[0]);
                }
                $(".zoom").magnify();
            }, 1000);
        });
    }

    changeDisplayDoc(other_document) {
        const self = this;

        if (!other_document){ return false; }

        $('#document_container').empty();

        if (!other_document.title) { other_document.title = other_document.name; }

        self.display_doc = other_document;

        if (!other_document.id) {
            $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + other_document.url + '"></iframe>');
        } else {
            self.getPresignedUrl(other_document.model, other_document.id, function (presigned_url){
                if(presigned_url){
                    $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + presigned_url + '"></iframe>');
                }
            })
        }
    }

    getPresignedUrl(model, id, callback) {
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model,
            'id': id,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response.data.presigned_url);
            }
        });
    }

    getAmlRiskAssessmentClass(risk_assessment_level){
        if(!risk_assessment_level) return;
        if(risk_assessment_level.toLowerCase() == 'low'){ return 'text-success';
        } else if(risk_assessment_level.toLowerCase() == 'medium'){  return 'text-warning';
        } else if(risk_assessment_level.toLowerCase() == 'high'){ return 'text-danger'; }
    }

    openCDDFormF(saleId){
        const self = this;

        self.SSAlertService.clear();

        let url = 'sec/developer/sales/'+saleId+'/get-form-f';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                if( response.data.sale_documents ) {
                    self.getPresignedUrl(self.ASSET_MODEL_SALE_DOCUMENT, response.data.sale_documents.id, function(presigned_url){
                        if(presigned_url){
                            window.open(presigned_url, '_blank');
                        }
                    })
                }else{
                    self.SSAlertService.danger(
                        'CDD Form G not yet generated, Please try again later. If you have not done the AML documents review, Please click Review button.');
                }
            }
        })
    }

    processDocuments(buyers, documents, buyer_type) {
        const self = this;

        //Process documents
        $.each(buyers, function (i, buyer) {

            let url = 'sec/assets/presigned-url';
            let params = null;

            $.each(documents, function (j, buyer_document) {
                let buyer_id = buyer.id;
                if(buyer_type == "sale_buyer"){
                    buyer_id = buyer.sale_buyer_id;
                } else if( buyer_type == "subsale_buyer" ){
                    buyer_id = buyer.subsale_buyer_id;
                }

                //prepare preview document
                if (buyer_document.file_uri
                    && buyer_document[buyer_type + '_id'] == buyer_id
                    && buyer_document.format == self.PROPERTY_DOCUMENT_FORMAT_IMG
                ) {
                    // Buyer IC/Passport etc.
                    url = 'sec/assets/presigned-url';
                    params = {
                        //'model': buyer_type == 'beneficiary' ? self.ASSET_MODEL_SALE_DOCUMENT : self.ASSET_MODEL_BUYER_DOCUMENT,
                        'model': buyer_type == "subsale_buyer" ? self.ASSET_MODEL_SUBSALE_DOCUMENT : self.ASSET_MODEL_SALE_DOCUMENT,
                        'id': buyer_document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        buyer_document["show_file_url"] = response.data.presigned_url;
                        buyer_document.model = buyer_type == "subsale_buyer" ? self.ASSET_MODEL_SUBSALE_DOCUMENT : self.ASSET_MODEL_SALE_DOCUMENT;

                        self.$timeout(function () {
                            $(".zoom").magnify();
                        }, 2000);

                    });

                    if (buyer) {
                        if (!buyer.documents) buyer.documents = {};
                        buyer.documents[buyer_document.document_kind] = buyer_document;
                    }
                }
            });
        });
    }

    downloadPic(file_obj, model_type) {
        const self = this;

        model_type = model_type ? model_type : file_obj.model;

        self.getPresignedUrl(model_type, file_obj.id, function (presigned_url){
            if(presigned_url){
                window.open(presigned_url, '_blank');
            }
        })
    }
    /* WEB-2835 Key Handover: Final AML Scans and Form F - END */

    /** WEB-2921 DMS: Import Unit Furnishing Package Import Imrovements **/
    checkFurnishingImportFilesAndShowPrompt(selectedFileType){
        const self = this;
        self.SSAlertService.clear();

        if(selectedFileType === "EXCEL"){
            if(!self.importParams.unitsAssetFiles){
                self.SSAlertService.info('', "Please also select Assets to proceed with upload");
            }
        } else if(selectedFileType === "ASSET"){
            if(!self.importParams.unitsExcelFile){
                self.SSAlertService.info('', "Please also select Data file to proceed with upload");
            }
        }
    }
}

PropertyKeyHandoverUnitSelectionController.$inject = ['$scope', '$timeout', '$window', 'Upload', 'OTPService', 'SSHttpService', 'SSAppService', 'SSUtilService', 'SSUserService', 'SSStorageService', 'SSAlertService', 'SSConfirmationService', 'SSConfigService', 'SSAwsService'];
app.controller('PropertyKeyHandoverUnitSelectionController', PropertyKeyHandoverUnitSelectionController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.
